// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__vx3eY","header":"PatientQuestionnaire_header__1w795","info":"PatientQuestionnaire_info__2diU5"};